// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"92d504e6","488":"520529fa","977":"138052d5"}[chunkId] + ".chunk.js";
};